import { render, staticRenderFns } from "./DocumentNumberTextField.vue?vue&type=template&id=370bc12c&scoped=true"
import script from "./DocumentNumberTextField.vue?vue&type=script&lang=js"
export * from "./DocumentNumberTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370bc12c",
  null
  
)

export default component.exports